import { IframeService as BaseIframeService } from '@pascal/iframe-service';
import { setHttpClientInterceptors } from '../http/httpClient';
import { applicationStore } from '../../store/applicationStore';
import { gameService } from '../GameService';

export const PostMessage = {
  PgReload: 'pgReload',
  PgLogout: 'pgLogout',
  PgGameLoaded: 'pgGameLoaded',
  PgLoginCheck: 'pgLoginCheck',
  PgGetAuthInfo: 'pgGetAuthInfo',
  PgRedirectHome: 'pgRedirectHome',
  PgRedirectLogin: 'pgRedirectLogin',
  ErrorReceived: 'errorReceived',
};

export const PostMessageListenerMessages = {
  UpdateBalance: 'updateBalance',
  StopAutoSpins: 'stopAutospins',
  AuthInfoUpdate: 'authInfoUpdate',
  OpenerIcons: 'openerIcons',
  TournamentUpdate: 'tournamentUpdate',
};

class IframeService extends BaseIframeService {
  sendParentMessage(message, transfer, targetOrigin = '*') {
    window.parent.postMessage(message, targetOrigin, transfer);
  }

  reloadFrame() {
    super.sendReload();
  }

  // redirectHome() {
  //   super.redirect(true);
  // }

  redirectHome() {
    this.sendParentMessage(PostMessage.PgRedirectHome);
  }

  isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  sendErrorReceived(payload) {
    this.sendParentMessage({ name: PostMessage.ErrorReceived, payload });
  }

  setPostMessageListener(messageParams) {
    if (!this.isInIframe()) {
      applicationStore.setIsAuthDataReceived(true);
    } else {
      window.addEventListener('message', (message) => {
        if (message.data && message.data.name === PostMessageListenerMessages.OpenerIcons) {
          applicationStore.setTournamentIconsInfo(message.data.icons);
        }
        if (message.data && message.data.name === PostMessageListenerMessages.TournamentUpdate) {
          gameService.getTournamentUpdate();
        }
        if (message.data && message.data.name === PostMessageListenerMessages.AuthInfoUpdate) {
          const { accessToken, isAuthenticated, isOperatorHandlesErrors } = message.data;
          applicationStore.setIsAuthenticated(isAuthenticated);
          applicationStore.setAccessToken(accessToken);
          applicationStore.setIsAuthDataReceived(true);
          applicationStore.setIsOperatorHandlesErrors(isOperatorHandlesErrors);
          setHttpClientInterceptors();
        }

        if (messageParams && messageParams.length) {
          messageParams.forEach(({ name, callback }) => {
            if (message.data && message.data.name === name) {
              callback(message.data);
            }
          });
        }
      });
    }
  }
}

const iframeService = new IframeService();

export { iframeService };
